import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Loader from "_shared/_views/loading/loader";
import VendorRolloutStatusBoard from "legal-entities/vendor-rollouts/_views/vendor-rollout-status-board";
import "permissions/__extensions/users/user-extensions";
import useSessionUser from "permissions/session/use-session-user";

// Bounded to the shell's content section, which clips with `overflow: hidden` and does not scroll
// itself. Without a height limit the paper grows past the viewport and its own `overflow: auto`
// never engages, so a long board is cut off rather than scrolled.
const PageContainer = styled(Paper)(({ theme }) => ({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  margin: theme.spacing(1),
  maxHeight: `calc(100% - ${theme.spacing(2)})`,
  overflow: "auto",
  padding: theme.spacing(2),
}));
const PageTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
}));
const PageIntroduction = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2),
  maxWidth: "48rem",
}));

/**
 * How far each of the firms this organization invited has got.
 *
 * The client's own half of the status board. It exists so nobody has to wait to be told: a client
 * who has just asked all of their outside counsel to change how they bill reads silence as failure,
 * whether or not anything is actually wrong.
 */
export default function FirmOnboardingStatusPage() {
  const user = useSessionUser();

  if (!user) return <Loader text="Loading firm onboarding status..." />;

  return (
    <PageContainer>
      <PageTitle variant="h5">Firm onboarding</PageTitle>
      <PageIntroduction variant="body2">
        How far each firm you have invited has got. Every date here is a step the platform recorded,
        not a status anybody typed in.
      </PageIntroduction>
      <VendorRolloutStatusBoard
        clientLegalEntityId={user.legalEntityId}
        emptyTitle="No firms yet"
        emptyDescription="Firms appear here once invitations go out to their team leaders."
      />
    </PageContainer>
  );
}
